// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_day_annotation.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_day_annotation.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_day_annotation = /*@__PURE__*/
  fileDesc("Cj9zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfZGF5X2Fubm90YXRpb24ucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMiRAoUUGxhbm5lckRheUFubm90YXRpb24SDQoFdGl0bGUYASABKAkSDgoGc3ltYm9sGAIgASgJEg0KBWNvbG9yGAMgASgJQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerDayAnnotation.
 * Use `create(PlannerDayAnnotationSchema)` to create a new message.
 */
export const PlannerDayAnnotationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_day_annotation, 0);

